<template>
  <div v-if="message" class="alert-container">
    <div :class="['alert-message', `alert-${message.type}`]">
      <i :class="getIconClass(message.type)"></i>
      <span>{{ message.text }}</span>
      <button class="alert-close" @click="removeMessage">×</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageNotification',
  props: {
    message: {
      type: Object,
      default: null
    }
  },
  methods: {
    getIconClass(type) {
      const iconMap = {
        error: 'uil-exclamation-triangle',
        success: 'uil-check-circle',
        warning: 'uil-exclamation-octagon',
        info: 'uil-info-circle'
      };
      return iconMap[type] || iconMap.info;
    },
    removeMessage() {
      this.$emit('remove');
    }
  }
};
</script>

<style scoped>
.alert-container {
  margin-bottom: 16px;
}

.alert-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.3s ease-out;
}

.alert-error {
  border: 1px solid #fecaca;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
}

.alert-success {
  border: 1px solid #bbf7d0;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  color: #16a34a;
}

.alert-warning {
  border: 1px solid #fed7aa;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  color: #d97706;
}

.alert-info {
  border: 1px solid #bfdbfe;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #2563eb;
}

.alert-message i {
  font-size: 16px;
  flex-shrink: 0;
}

.alert-error i {
  color: #dc2626;
}

.alert-success i {
  color: #16a34a;
}

.alert-warning i {
  color: #d97706;
}

.alert-info i {
  color: #2563eb;
}

.alert-message span {
  flex: 1;
}

.alert-close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
}

.alert-error .alert-close {
  color: #dc2626;
}

.alert-success .alert-close {
  color: #16a34a;
}

.alert-warning .alert-close {
  color: #d97706;
}

.alert-info .alert-close {
  color: #2563eb;
}

.alert-close:hover,
.alert-close:active {
  transform: scale(1.1);
}

.alert-error .alert-close:hover,
.alert-error .alert-close:active {
  background: rgba(220, 38, 38, 0.1);
}

.alert-success .alert-close:hover,
.alert-success .alert-close:active {
  background: rgba(22, 163, 74, 0.1);
}

.alert-warning .alert-close:hover,
.alert-warning .alert-close:active {
  background: rgba(217, 119, 6, 0.1);
}

.alert-info .alert-close:hover,
.alert-info .alert-close:active {
  background: rgba(37, 99, 235, 0.1);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
